import { useAuthentication } from '@topcon/topcon-utils';
import { Navigate } from 'react-router-dom';

import { useAppService } from '../../providers/app/app.context';
import { AppRoutes } from '../../app/routes/utils';
import Redirect from './Redirect';

function AboutMe() {
  const { getLoginURL } = useAuthentication();
  const { loadedBusinessPartner, currentBusinessPartner } = useAppService();
  if (!loadedBusinessPartner) return null;
  if (currentBusinessPartner) {
    return <Redirect to={getLoginURL(true, 'nobp')} />;
  }
  return <Navigate to={AppRoutes.Overview} />;
}

export default AboutMe;
